import * as React from 'react';

import { Grid,  Button, Checkbox, Link } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import SearchIcon from '@material-ui/icons/Search';



interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
    checked1: boolean
    checked2: boolean
    checked3: boolean
}



class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();


    let c1 = false
    let c2 = false
    let c3 = false
 
    let link = this.props.page.gdzieLink

    if(link === 1) c1 = true
    if(link === 2) c2 = true
    if(link === 3) c3 = true
   
    this.state = {
        checked1: c1,
        checked2: c2,
        checked3: c3,
    }
  }

  componentDidMount() {
  }

  openRegulamin = () => {
    
  }

  handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(!this.state.checked1){
      this.setState({checked1: true, checked2: false, checked3: false});
      store.dispatch(Actions.pageState.setGdzieLink(1));
    }
    //this.setState({[event.target.name]: event.target.checked});
  };
  change1 = () => {
    if(!this.state.checked1){
      this.setState({checked1: true, checked2: false, checked3: false});
      store.dispatch(Actions.pageState.setGdzieLink(1));
    }

  } 
  handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(!this.state.checked2){
      this.setState({checked1: false, checked2: true, checked3: false});
      store.dispatch(Actions.pageState.setGdzieLink(2));
    }
  };
  change2 = () => {
    if(!this.state.checked2){
      this.setState({checked1: false, checked2: true, checked3: false});
      store.dispatch(Actions.pageState.setGdzieLink(2));
    }
  } 
  handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(!this.state.checked3){
      this.setState({checked1: false, checked2: false, checked3: true});
      store.dispatch(Actions.pageState.setGdzieLink(3));
    }
  };
  change3 = () => {
    if(!this.state.checked3){
      this.setState({checked1: false, checked2: false, checked3: true});
      store.dispatch(Actions.pageState.setGdzieLink(3));
    }
  }

  
  render() {
    const { classes, t } = this.props;
    let primary = theme.palette.primary.main

    let disabled = !this.props.page.jestKarnet
    

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} style={{paddingLeft: "0",paddingRight: "0"}}>

              <div style={{ width: "fit-content", margin: "auto" }}>
                
                <Typography variant="h6" component="h2" onClick={() => !disabled ? this.change1() : store.dispatch(Actions.pageState.setOpenInfo())} color='textSecondary' className={`${classes.text} ${classes.color}`} style={{ cursor: "pointer" }}>
                  <Checkbox
                    checked={this.state.checked1}
                    onChange={this.handleChange1}
                    name='checked1'
                    style={{ marginLeft: "-9px", color: "rgb(255, 165, 0)" }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    disabled={disabled}
                  />
                  {"tylko na Twoim smartfonie"}<b className={classes.primary} >{ }</b>
                </Typography>
                <Typography  variant="h6" component="h2" onClick={() => !disabled ? this.change2() : store.dispatch(Actions.pageState.setOpenInfo())} color='textSecondary' className={`${classes.text} ${classes.color}`} style={{ cursor: "pointer" }}>
                  <Checkbox
                    checked={this.state.checked2}
                    onChange={this.handleChange2}
                    style={{ marginLeft: "-9px", color: "rgb(255, 165, 0)" }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    disabled={disabled}
                  />
                  {"dowolna przeglądarka\n+ sms do Ciebie"}<b className={classes.primary} >{ }</b>
                </Typography>
                <Typography variant="h6" component="h2" onClick={() => !disabled ? this.change3() : store.dispatch(Actions.pageState.setOpenInfo())} color='textSecondary' className={`${classes.text} ${classes.color}`} style={{ cursor: "pointer" }}>
                  <Checkbox
                    checked={this.state.checked3}
                    onChange={this.handleChange3}
                    style={{ marginLeft: "-9px", color: "rgb(255, 165, 0)" }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    disabled={disabled}
                  />
                  {"dowolna przeglądarka\nbez ograniczeń"}<b className={classes.primary} >{ }</b>
                </Typography>

              </div>   

              
              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      color: {
        color: "lightseagreen",
        //color: theme.palette.primary.main
      },
      text: {
        //color: theme.palette.text.secondary,
        whiteSpace: "break-spaces" as "break-spaces",
        minHeight: "12px",
        //maxHeight: "25.6px",
        marginBottom: '12px',
        fontSize: "16px",
    
        display: "flex" as "flex",
        //justyfyContent: "center",
        alignItems: "center"
      },
      icon: {
        fontSize: "28px", 
        color: "rgb(255, 165, 0)", 
        marginRight: "6px"
      },
  container1: {
    //margin: "0em",
    //paddingTop: "0.4em",
    margin: "30px auto 0px",
    padding: '0em 0em',
    minHeight: "100%",
    maxWidth: "1340px",
    //border: "2px solid lavender"
  },
  gridItem: {
    minHeight: "150px",
  },
  item: {
    height: "40px",
    textAlign: "center" as "center",
    border: "1px solid lavender",
    marginBottom: "4px",
    backgroundColor: "#FCFCFC", //"#F5F5F5",
    "&:hover": {
      backgroundColor: "#F1F1F1", //"#EEE"
    },
  },
  itemText: {
    color: "rgb(255, 165, 0)",
    fontSize: "16px"//"2.5rem"
  }
 
  
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 


{/* <ListItem
key={'2'}
button

onClick={() => this.openRegulamin()}
className={classes.item}
style={{height: "60px"}}
>


<ListItemText
    primary={<Typography color="primary" className={classes.itemText} ><b>{"Przeczytałem(-am) i akceptuję regulamin wypożyczenia"}</b></Typography>}

/>
</ListItem>
 */}
